module.exports = __webpack_public_path__ + "img/avatar7.37920867.png";